var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockCircleTime(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 5.14372V8.00086L10.9029 11.3837M8.00023 15.4294C9.97041 15.4294 11.8599 14.6468 13.253 13.2536C14.6461 11.8605 15.4288 9.97102 15.4288 8.00084C15.4288 6.03066 14.6461 4.14117 13.253 2.74804C11.8599 1.35492 9.97041 0.572266 8.00023 0.572266C6.03005 0.572266 4.14056 1.35492 2.74743 2.74804C1.35431 4.14117 0.571655 6.03066 0.571655 8.00084C0.571655 9.97102 1.35431 11.8605 2.74743 13.2536C4.14056 14.6468 6.03005 15.4294 8.00023 15.4294Z",
    stroke: "#8C3B08",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockCircleTime);
export default __webpack_public_path__ + "static/media/clock-circle-time.5574fc13818746655f2e7e1b1d3553bc.svg";
export { ForwardRef as ReactComponent };